import React from 'react'
import injectSheet from 'react-jss'
import styles from './heading.styles'
import classNames from 'classnames'
import { withPresentation } from '../../presentation-connectors'

const Heading = ({ classes, children, className, style }) => (
  <h2 className={classNames(classes.heading, className)} style={style}>
    {children}
  </h2>
)

export default withPresentation(injectSheet(styles)(Heading))
